module.exports = __webpack_public_path__ + "img/1.bf23983.png";